import present_i from "../images/icons/ep_present.svg";
import gsm_i from "../images/icons/ep_gsm.svg";
import search_i from "../images/icons/ep_search.svg";
import service_i from "../images/icons/ep_service.svg";
import shield_i from "../images/icons/ep_shield.svg";

const count = {
  preface: 13,
   cityray: 10,
  atlas_pro: 29,
  okavango: 22,
  tugella: null,
  coolray: 22,
  atlas_new: 23,
  new_coolray: 19,
  atlas: 5,
  monjaro: 26,
  emgrand: 25,
  monjaro_hybrid: 30,
};

const adv_num = {
  atlas_pro: 6,
  okavango: 6,
  tugella: 4,
  coolray: 3,
  atlas_new: 3,
  new_coolray: 3,
  atlas: 2,
  monjaro: null,
  emgrand: 3,
  monjaro_hybrid: 3
};

const advantages = {
  atlas_pro: "900 000",
  okavango: "950 000",
  tugella: "680 000",
  coolray: "700 000",
  atlas_new: "900 000",
  new_coolray: "700 000",
  atlas: "390 000",
  monjaro: "1 300 000",
  preface: "900 000",
  cityray: "800 000",
  emgrand: "750 000",
  monjaro_hybrid: "1 000 000",
};

const tradein = {
  atlas_pro: "270 000",
  okavango: "270 000",
  tugella: "250 000",
  coolray: "235 000",
  atlas_new: "235 000",
  new_coolray: "235 000",
  atlas: "220 000",
  monjaro: null,
  preface: null,
  cityray: null,
  emgrand: "235 000",
  monjaro_hybrid: "235 000"
};

const credit_discount = {
  atlas_pro: "220 000",
  okavango: "220 000",
  tugella: "200 000",
  coolray: "185 000",
  atlas_new: "185 000",
  new_coolray: "185 000",
  atlas: "170 000",
  monjaro: null,
  preface: null,
  cityray: null,
  emgrand: "185 000",
  monjaro_hybrid: "185 000"
};

const credit = {
  atlas_pro: "0,01",
  okavango: "0,01",
  tugella: "0,01",
  coolray: "0,01",
  atlas_new: "0,01",
  new_coolray: "0,01",
  atlas: "0,01",
  monjaro: "0,01",
  preface: "0,01",
  cityray: "0,01",
  emgrand: "0,01",
  monjaro_hybrid: "0,01"
};

const features = {
  atlas_pro: false,
  okavango: false,
  tugella: false,
  coolray: false,
  atlas_new: false,
  new_coolray: false,
  atlas: false,
  monjaro: false,
  preface: false,
  cityray: false,
  emgrand: false,
  monjaro_hybrid: false
};

const fresh = ['ex5'];

const CARS = [
	{
		key: "monjaro",
		name: "Monjaro",
		images: 6,
		colors: [
			{
				color: "#2D7289",
				image: "emerald",
			},
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#5e6775",
				image: "dark-grey",
			},
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#d6d6d6",
				image: "light-grey",
			},
			{
				color: "#FFFFFF",
				image: "white",
			},
		],
		activeColor: "white",
		gallery: 5,
	},
	{
		key: "okavango",
		name: "okavango",
		images: 4,
		colors: [
			{
				color: "#0069b4",
				image: "blue",
			},
			{
				color: "#000",
				image: "black",
			},
			{
				color: "#888",
				image: "grey",
			},
			{
				color: "#fff",
				image: "white",
			},
		],
		activeColor: "blue",
		gallery: 9,
	},
	// {
	//   key: "monjaro_hybrid",
	//   name: "MONJARO ГИБРИД",
	//   images: 1,
	// },
	{
		key: "preface",
		name: "Preface",
		images: 6,
		colors: [
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#ffffff",
				image: "white",
			},
			{
				color: "#9083b9",
				image: "purple",
			},
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#829ac7",
				image: "blue",
			},
			{
				color: "#1A3C24",
				image: "green",
			},
		],
		activeColor: "grey",
		gallery: 3,
	},
	{
		key: "atlas_new",
		name: "ATLAS",
		images: 5,
		colors: [
			{
				color: "#4c5698",
				image: "blue",
			},
			{
				color: "#1a1b1d",
				image: "black",
			},
			{
				color: "#828793",
				image: "silver",
			},
			{
				color: "#1A3C24",
				image: "green",
			},
			{
				color: "#f1f3f4",
				image: "white",
			},
		],
		activeColor: "blue",
		gallery: 10,
	},
	// {
	//   key: "atlas_pro",
	//   name: "Atlas Pro",
	//   images: 4,
	// },
	{
		key: "cityray",
		name: "Cityray",
		images: 4,
		gallery: 5,
		colors: [
			{
				color: "#829ac7",
				image: "blue",
			},
			{
				color: "#ffffff",
				image: "white",
			},
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#d6d6d6",
				image: "light-grey",
			},
		],
		activeColor: "blue",
	},
	// {
	//   key: "coolray",
	//   name: "Coolray",
	//   images: 4,
	// },
	{
		key: "emgrand",
		name: "emgrand",
		images: 6,
		colors: [
			{
				color: "#47B7D3",
				image: "cyan",
			},
			{
				color: "#FCEFB4",
				image: "gold",
			},
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#FDFFFD",
				image: "white",
			},
			{
				color: "#676B6C",
				image: "grey",
			},
			{
				color: "#bdc9d5",
				image: "lilac",
			},
		],
		activeColor: "cyan",
		gallery: 5,
	},
	{
		key: "new_coolray",
		name: "COOLRAY",
		images: 5,
		colors: [
			{
				color: "#BEAEC6",
				image: "lilac",
			},
			{
				color: "#676B6C",
				image: "grey",
			},
			{
				color: "#FDFFFD",
				image: "white",
			},
			{
				color: "#47B7D3",
				image: "cyan",
			},
			{
				color: "#FF0005",
				image: "red",
			},
		],
		activeColor: "lilac",
		gallery: 5,
	},
	// {
	// 	key: "ex5",
	// 	name: "EX5",
	// 	images: 5,
	// 	colors: [
	// 		{
	// 			color: "#0069b4",
	// 			image: "blue",
	// 		},
	// 		{
	// 			color: "#000",
	// 			image: "black",
	// 		},
	// 		{
	// 			color: "#888",
	// 			image: "grey",
	// 		},
	// 		{
	// 			color: "#fff",
	// 			image: "white",
	// 		},
	// 		{
	// 			color: "#5e6775",
	// 			image: "dark-grey",
	// 		},
	// 	],
	// 	activeColor: "blue",
	// 	gallery: 3,
	// },
	// {
	//   key: "tugella",
	//   name: "Tugella",
	//   images: 4,
	// },

	// {
	//   key: "atlas",
	//   name: "Atlas",
	// },
].map((car) => {
	car.count = count[car.key];
	car.advantage = advantages[car.key];
	car.adv_num = adv_num[car.key];
	car.tradein = tradein[car.key];
	car.credit = credit[car.key];
	car.credit_discount = credit_discount[car.key];
	(car.features = [
		{ text: "Керамическое покрытие", icon: search_i },
		{ text: "Сигнализация с GSM и управлением с телефона", icon: gsm_i },
		{ text: "Антишум", icon: shield_i },
		{ text: "Установка защитной сетки в бампер", icon: service_i },
		{ text: "Защита радиатора", icon: search_i },
		{ text: "Защита картера", icon: gsm_i },
		{ text: "Тонировка", icon: shield_i },
		{ text: "Ковры", icon: service_i },
	]),
		(car.fresh = fresh.includes(car.key));
	car.benefits = [
		{
			id: "advantage",
			icon: "agree",
			text: advantages[car.key]
				? `Выгода до <span class="price">${
						advantages[car.key]
				  } ₽</span><sup>*</sup>`
				: `Выгода по запросу`,
			alt: advantages[car.key]
				? `Выгода до <span class="price">${
						advantages[car.key]
				  } ₽</span><sup>*</sup>`
				: `Выгода по запросу`,
		},
		{
			icon: "agree",
			text: `<span class="red-text">Рассрочка</span>*`,
			alt: `<span class="red-text">Рассрочка</span>*`,
		},
		{
			icon: "agree",
			text: `Гарантия 5 лет*`,
			alt: `Гарантия 5 лет*`,
		},
		{
			icon: "gift",
			text: `ДОП в подарок! (дарим подарки на выбор: керамическое покрытие, сигнализация с GSM и управлением с телефона, установка защитной сетки в бампер, защита радиатора, защита картера, тонировка, ковры, антишум)`,
			alt: `ДОП в подарок`,
		},
		{
			icon: "gift",
			text: `КАСКО в подарок!`,
			alt: `КАСКО в подарок!`,
		},
		{
			icon: "gift",
			text: `ТО-0 в подарок`,
			alt: `ТО-0 в подарок`,
		},
		{
			icon: "gift",
			text: `ТО-5 в подарок`,
			alt: `ТО-5 в подарок`,
		},
		{
			icon: "gift",
			text: `Кэшбек на карту Автомир!`,
			alt: `Кэшбек на карту Автомир!`,
		},
		{
			icon: "gift",
			text: `А/С с автозапуском!`,
			alt: `А/С с автозапуском!`,
		},
		{
			icon: "gift",
			text: `Оригинальные аксессуары!`,
			alt: `Оригинальные аксессуары!`,
		},
		{
			icon: "gift",
			text: `Комплект шин!`,
			alt: `Комплект шин!`,
		},
		/*{
      icon: "gift",
      text: `Комплект колес в сборе!`,
      alt: `Комплект колес в сборе!`,
    },*/
		{
			icon: "gift",
			text: `Керамическое покрытие!`,
			alt: `Керамическое покрытие!`,
		},
		{
			icon: "gift",
			text: `Полный БАК бензина в подарок! `,
			alt: `Полный БАК бензина в подарок! `,
		},
	];

	// если advantages[car.key] === false => удалить выгоду из списка
	if (!advantages[car.key]) {
		let advantageIndex = car.benefits.findIndex((benefit) => {
			return benefit.id === "advantage";
		});

		// для new_coolray и emgrand добавляем другую выгоду
		const specAdvModels = [
			"okavango",
			"atlas_new",
			"new_coolray",
			"monjaro",
			"emgrand",
			"preface",
			"cityray",
		];
		if (specAdvModels.includes(car.key)) {
			car.benefits.splice(advantageIndex, 1, {
				id: "advantage",
				icon: "agree",
				text: '<span class="red-text">Специальная выгода</span>',
				alt: '<span class="red-text">Специальная выгода</span>',
			});
		} else {
			// car.benefits.splice(advantageIndex, 1)
		}
	}

	if (car.key === "monjaro_hybrid") {
		car.accent = "Hi-P Hybrid (гибрид)";
		car.benefits = [car.benefits[0]].concat(car.benefits.slice(2));
		car.benefits.splice(0, 1, {
			id: "advantage",
			icon: "agree",
			text: `Выгода до <span class="price">${advantages["monjaro_hybrid"]} ₽</span><sup>*</sup>`,
			alt: `Выгода до <span class="price">${advantages["monjaro_hybrid"]} ₽</span><sup>*</sup>`,
		});
	}

	return car;
});

export default CARS;
